import Vue from 'vue';

function isMobile() {
    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) ) {
        return true
    } else {
        return false
    }
}
export default () => {
    Vue.directive( 'ep-restrict', {
        bind( el, binding, vnode ) {
            if ( isMobile() && binding.modifiers[ 'number' ] && el.type !== 'password' && el.title !== "amount" ) {
                el.type = 'number'
            }
            let cmdDown = false,
                cmdKey = 91

            $( document ).keydown( function ( e ) {
                if ( e.keyCode == cmdKey ) {
                    cmdDown = true;
                }
            } ).keyup( function ( e ) {
                if ( e.keyCode == cmdKey ) {
                    cmdDown = false;
                }
            } );
            el.addEventListener( 'input', ( event ) => {
                if ( /Android|IEMobile|Opera Mini/i.test( navigator.userAgent ) ) {
                    const element = el;
                    const limit = el.maxLength;

                    const value = element.value.substr( 0, limit );
                    if ( value.length <= limit ) {
                        element.value = value;
                    } else {
                        element.value = value.substr( 0, limit - 1 );
                    }
                }
            } )
            el.addEventListener( 'keydown', ( e ) => {
                if ( binding.modifiers[ 'readonly' ] ) {
                    // return false
                }
                // delete, backpsace, tab, escape, enter,
                let special = [ 46, 8, 9, 27, 13 ]
                if ( binding.modifiers[ 'decimal' ] ) {
                    // decimal(numpad), period
                    special.push( 110, 190 )
                }
                // special from above
                if ( special.indexOf( e.keyCode ) !== -1 ||
                    // Ctrl+A
                    ( e.keyCode === 65 && ( e.ctrlKey === true || cmdDown ) ) ||
                    // Ctrl+C
                    ( e.keyCode === 86 && ( e.ctrlKey === true || cmdDown ) ) ||
                    // Ctrl+V
                    ( e.keyCode === 67 && ( e.ctrlKey === true || cmdDown ) ) ||
                    // Ctrl+X
                    ( e.keyCode === 88 && ( e.ctrlKey === true || cmdDown ) ) ||
                    // home, end, left, right
                    ( e.keyCode >= 35 && e.keyCode <= 39 ) ) {
                    return // allow
                }
                if ( ( binding.modifiers[ 'alpha' ] ) &&
                    // a-z/A-Z
                    ( ( e.keyCode >= 65 && e.keyCode <= 90 ) || ( e.keyCode == 32 || e.keyCode == 222 || e.keyCode == 189 || e.keyCode == 188 || e.keyCode == 190 || e.keyCode == 192 || e.keyCode == 110 ) ) ) {
                    return // allow
                }
                if ( ( binding.modifiers[ 'number' ] ) &&
                    // number keys without shift
                    ( ( !e.shiftKey && ( e.keyCode >= 48 && e.keyCode <= 57 ) ) ||
                        // numpad number keys
                        ( e.keyCode >= 96 && e.keyCode <= 105 ) ) &&
                    el.value.length < el.maxLength ) {
                    return // allow
                }
                // otherwise stop the keystroke
                e.preventDefault() // prevent
            } ) // end keydown addEventListener
            el.addEventListener( "paste", ( e ) => {
                e.preventDefault();
                let clipboard = e.clipboardData
                let text = clipboard.getData( 'Text' )
                if ( binding.modifiers[ 'number' ] ) {
                    event.target.value = text.replace( /[^0-9]+/g, '' )
                    vnode.elm.dispatchEvent( new CustomEvent( 'input' ) );
                }
                if ( binding.modifiers[ 'alpha' ] ) {
                    event.target.value = text.replace( /[^a-zA-Z' .\-_]+/g, '' )
                    vnode.elm.dispatchEvent( new CustomEvent( 'input' ) );
                }
            }, false ); // end paste addEventListener
        } // end bind
    } ) // end directive

};